module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (265).bf8eb611.jpg";